import React from 'react'
import { motion } from 'framer-motion'
import './Experience.css'

const Experience = () => {
  const experiences = [
    {
      id: 1,
      role: 'Web Developer',
      company: 'DCLM (Deeper Life Campus Fellowship)',
      location: 'OAU Ife, Nigeria',
      period: '2022 - Present',
      description: 'Leading the development and maintenance of the campus fellowship\'s digital platforms, including member management systems, event scheduling, and communication tools.',
      achievements: [
        'Built a comprehensive member management system serving 500+ students',
        'Developed event scheduling platform with real-time updates',
        'Implemented automated communication system for announcements',
        'Reduced manual administrative work by 60%'
      ],
      technologies: ['React.js', 'Node.js', 'MongoDB', 'Express.js']
    },
    {
      id: 2,
      role: 'Full Stack Developer',
      company: 'Delben Schools',
      location: 'Nigeria',
      period: '2022 - Present',
      description: 'Developing and maintaining the school\'s web portal, including student enrollment, grade tracking, and parent communication features.',
      achievements: [
        'Created student enrollment system processing 1000+ applications',
        'Built grade tracking dashboard for teachers and parents',
        'Implemented secure parent-teacher communication portal',
        'Improved system performance by 40%'
      ],
      technologies: ['React.js', 'Next.js', 'PostgreSQL', 'Node.js']
    },
    {
      id: 3,
      role: 'Web Developer',
      company: 'Mercan School',
      location: 'Nigeria',
      period: '2021 - 2022',
      description: 'Designed and developed interactive educational platform with course management and student progress tracking capabilities.',
      achievements: [
        'Built course management system with 50+ courses',
        'Developed student progress tracking analytics',
        'Created interactive learning modules',
        'Increased student engagement by 35%'
      ],
      technologies: ['Next.js', 'TypeScript', 'MongoDB', 'Tailwind']
    },
    {
      id: 4,
      role: 'Frontend Developer',
      company: 'De Sons Voice',
      location: 'Nigeria',
      period: '2021 - 2022',
      description: 'Developed media and content platform with dynamic content management and multimedia integration for storytelling.',
      achievements: [
        'Built dynamic content management system',
        'Implemented multimedia integration features',
        'Created responsive design for all devices',
        'Improved page load speed by 50%'
      ],
      technologies: ['React.js', 'Firebase', 'Node.js', 'AWS']
    },
    {
      id: 5,
      role: 'Web Developer',
      company: 'TumiCodes',
      location: 'Nigeria',
      period: '2020 - 2021',
      description: 'Contributed to developer learning platform with interactive coding challenges and community features.',
      achievements: [
        'Developed interactive coding challenge system',
        'Built project showcase gallery',
        'Created community discussion forums',
        'Helped 200+ developers improve their skills'
      ],
      technologies: ['React.js', 'Node.js', 'MongoDB', 'Socket.io']
    }
  ]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.2
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  }

  return (
    <section id="experience" className="experience section">
      <div className="container">
        <motion.div
          className="experience-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <motion.div className="experience-header" variants={itemVariants}>
            <span className="section-label">Experience</span>
            <h2 className="section-title">
              Professional <span className="text-gradient">Journey</span>
            </h2>
            <p className="section-subtitle">
              A timeline of my professional experience, showcasing my growth and contributions
              to various organizations and projects.
            </p>
          </motion.div>

          <div className="timeline">
            {experiences.map((exp, index) => (
              <motion.div
                key={exp.id}
                className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
                variants={itemVariants}
              >
                <div className="timeline-marker">
                  <div className="marker-dot"></div>
                  <div className="marker-line"></div>
                </div>
                <motion.div
                  className="timeline-content glass-card"
                  whileHover={{ y: -5 }}
                >
                  <div className="timeline-header">
                    <span className="timeline-period">{exp.period}</span>
                    <h3 className="timeline-role">{exp.role}</h3>
                    <div className="timeline-company">
                      <span className="company-name">{exp.company}</span>
                      <span className="company-location">{exp.location}</span>
                    </div>
                  </div>
                  <p className="timeline-description">{exp.description}</p>
                  <div className="timeline-achievements">
                    <h4>Key Achievements:</h4>
                    <ul>
                      {exp.achievements.map((achievement, achIndex) => (
                        <li key={achIndex}>{achievement}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="timeline-technologies">
                    {exp.technologies.map((tech, techIndex) => (
                      <span key={techIndex} className="tech-badge">
                        {tech}
                      </span>
                    ))}
                  </div>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default Experience
